import ResponsiveTopNavigation from '../../components/navigation/ResponsiveTopNavigation';
import RestaurantHeader from './components/RestaurantHeader';
import RestaurantInfo from './components/RestaurantInfo';
import DiscountButtons from './components/DiscountButtons';
import CategoryTabs from './components/CategoryTabs';
import ProductGrid from './components/ProductGrid';
import ProductCustomizationModal from './components/ProductCustomizationModal';
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { base_url } from 'Backend/api';
import toast from 'react-hot-toast';
import Footer from 'components/Footer';
import AppSpinner from 'components/ui/AppSpinner';
import FavoriteToggleDialog, {
  useFavoriteToggleDialog,
} from 'components/favorites/FavoriteToggleDialog';
import { formatStoreTime12h } from 'utils/formatStoreTime';


const MarketDetailsPage = () => {
  const { slug } = useParams();
  const location = useLocation();

  const [restaurant, setRestaurant] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [addingId, setAddingId] = useState(null);
  const [favoriteLoading, setFavoriteLoading] = useState(false);
  const { showDialog, dialogMessage, showFavoriteDialog } =
    useFavoriteToggleDialog();

  useEffect(() => {
    const fetchRestaurantDetails = async () => {
      try {
        setIsUpdating(true);
        const token = localStorage.getItem("token");
        const headers = { Accept: "application/json" };
        if (token) headers.Authorization = `Bearer ${token}`;

        const response = await fetch(`${base_url}/api/markets/${slug}`, {
          headers,
        });
        const result = await response.json();

        if (result.status) {
          const apiMarket = result.data || {};
          const fallbackFavorite = location.state?.isFavorite;
          setRestaurant({
            ...apiMarket,
            is_favorite:
              typeof apiMarket?.is_favorite === "boolean"
                ? apiMarket.is_favorite
                : !!fallbackFavorite,
          });
        }
      } catch (error) {
        console.error("Error fetching restaurant:", error);
      } finally {
        setIsUpdating(false);
      }
    };

    fetchRestaurantDetails();
  }, [slug, location.state]);



  // const categoryTabs =
  //   restaurant?.tabs?.categories?.map((cat) => ({
  //     id: `category_${cat.category_id || cat.category_name}`,
  //     label: cat.category_name,
  //     items: cat.dishes || []
  //   })) || [];
  // تحويل الكاتيجوريز مع الساب كاتيجوريز ل Tabs
  const categoryTabs = restaurant?.tabs?.categories?.map((cat) => {
    // دمج كل المنتجات من كل sub_category
    const products = cat.sub_categories?.flatMap(sub => sub.products || []) || [];

    return {
      id: `category_${cat.category_id}`,
      label: cat.category_name,
      items: products
    };
  }) || [];

  const baseTabs = [
    {
      id: "popular_products",
      label: restaurant?.tabs?.popular_products?.title,
      items: restaurant?.tabs?.popular_products?.items || []
    },
    {
      id: "offers",
      label: restaurant?.tabs?.offers?.title,
      items: restaurant?.tabs?.offers?.items || []
    }
  ].filter(tab => tab.items.length > 0);

  const allTabs = [...baseTabs, ...categoryTabs];
  const hasOpenNowFlag =
    restaurant?.is_open_now === true ||
    restaurant?.is_open_now === false ||
    restaurant?.is_open_now === 1 ||
    restaurant?.is_open_now === 0;
  const isMarketOpen = hasOpenNowFlag
    ? restaurant?.is_open_now === true || restaurant?.is_open_now === 1
    : restaurant?.is_active === true ||
      restaurant?.is_active === 1 ||
      restaurant?.status === "active" ||
      restaurant?.status === "open" ||
      restaurant?.status_code === "active";
  const isMarketClosed = restaurant ? !isMarketOpen : false;

  const opensAt = formatStoreTime12h(
    restaurant?.delivery?.opens_at ?? restaurant?.timing?.opens_at
  );
  const closesAt = formatStoreTime12h(
    restaurant?.delivery?.closes_at ?? restaurant?.timing?.closes_at
  );

  useEffect(() => {
    if (allTabs.length > 0 && !activeTab) {
      setActiveTab(allTabs[0].id);
    }
  }, [allTabs, activeTab]);

  const activeProducts =
    allTabs.find(tab => tab.id === activeTab)?.items || []

  // const handleProductCustomize = (product) => {
  //   setSelectedProduct(product);
  //   setIsModalOpen(true);
  // };
  const handleProductCustomize = async (product) => {
    try {
      // جلب بيانات التخصيص
      const response = await fetch(
        `${base_url}/api/markets/${restaurant?.slug}`
      );
      const result = await response.json();

      if (result.status) {
        // تحديث state مع البيانات الديناميكية
        setSelectedProduct({
          ...product,
          ingredients: result.data.ingredients || [],
          addons: result.data.addons || [],
          drinks: result.data.drinks || [],
          base_price: result.data.dish?.base_price || product?.price || 0
        });

        setIsModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching customization:", error);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  const handleAddToCart = async (product) => {
    if (isMarketClosed) return;
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        toast.error("يجب تسجيل الدخول أولاً");
        return;
      }

      setAddingId(product.id);

      const response = await fetch(`${base_url}/api/cart/items`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          store_type: "market",
          market_slug: restaurant?.slug,
          product_slug: product?.slug,
          quantity: 1,
        }),
      });

      const result = await response.json();

      if (response.ok && result.status) {
        toast.success("تمت إضافة المنتج إلى السلة ", {
          duration: 3000,
        });
        window.dispatchEvent(new Event("cartUpdated"));
      } else {
        toast.error(result.message || "حدث خطأ أثناء الإضافة");
      }
    } catch (error) {
      console.error("Add to cart error:", error);
      toast.error("حدث خطأ في الاتصال بالسيرفر");
    } finally {
      setAddingId(null);
    }
  };

  const handleToggleFavorite = async () => {
    if (!restaurant?.slug) return;

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("يجب تسجيل الدخول أولاً");
        return;
      }

      setFavoriteLoading(true);
      const response = await fetch(
        `${base_url}/api/favorites/markets/${restaurant.slug}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.status === false) {
        toast.error(result.message || "حدث خطأ");
        return;
      }

      const currentFavorite = !!restaurant?.is_favorite;
      const nextFavorite =
        typeof result?.data?.is_favorite === "boolean"
          ? result.data.is_favorite
          : !currentFavorite;

      setRestaurant((prev) =>
        prev
          ? {
              ...prev,
              is_favorite: nextFavorite,
            }
          : prev
      );

      showFavoriteDialog(nextFavorite);
    } catch (error) {
      console.error("Error toggling favorite:", error);
      toast.error("حدث خطأ في الشبكة");
    } finally {
      setFavoriteLoading(false);
    }
  };

  return (
    <>
      <div className="min-h-screen bg-white">
        <ResponsiveTopNavigation />
        <div
          className={`pt-10 md:pt-10 font-[cairo] ${
            isMarketClosed ? "pb-48 lg:pb-40" : "pb-24"
          }`}
        >
          <div className="max-w-5xl mx-auto">
            <RestaurantHeader
              restaurant={restaurant}
              isFavorite={!!restaurant?.is_favorite}
              favoriteLoading={favoriteLoading}
              onFavoriteToggle={handleToggleFavorite}
            />
            <RestaurantInfo restaurant={restaurant} />
            <DiscountButtons offers={restaurant?.offers} />
            <CategoryTabs
              tabs={allTabs}
              activeTab={activeTab}
              onTabChange={setActiveTab} />


            <div className="">
              <h2 className="text-sm md:text-lg font-medium p-2 bg-[#F8F8F8] text-foreground font-[cairo]">
                {allTabs.find(tab => tab.id === activeTab)?.label} (
                {activeProducts.length})
              </h2>
              <ProductGrid
                products={activeProducts}
                onAddToCart={handleAddToCart}
                addingId={addingId}
                isMarketClosed={isMarketClosed}
              />
            </div>
          </div>
        </div>

        {isUpdating && (
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
            <AppSpinner />
          </div>
        )}

        {isMarketClosed && (
          <div className="fixed inset-x-0 bottom-[45px] z-[100] pb-3 lg:bottom-0">
            <div
              dir="rtl"
              className="mx-auto max-w-3xl rounded-[0px] border border-[#F3D2B8] bg-[#FFF3E8] px-4 py-3 font-[cairo]"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="text-right">
                  <div className="flex items-center gap-1 text-[12px] font-medium text-[#F93209]">


                    <span className="shrink-0 pt-0.5">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                          stroke="#F93209"
                          strokeWidth="2"
                        />
                        <path
                          d="M12 10V16"
                          stroke="#F93209"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <path
                          d="M12 7H12.01"
                          stroke="#F93209"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </span>
                    <span>غير متاح حالياً</span>
                  </div>
                  <div className="mt-0.5 text-[14px] text-[#1F2937]">
                    سيكون متاحاً من{" "}
                    {opensAt && closesAt ? `${opensAt}-${closesAt}` : "—"}
                  </div>
                </div>


              </div>
            </div>
          </div>
        )}

        <FavoriteToggleDialog open={showDialog} message={dialogMessage} />

      </div>
      {/* <Footer/> */}
    </>
  );

};

export default MarketDetailsPage;